import { put, takeLatest } from "redux-saga/effects";
import NetworkHandler from "../net/NetworkHandler";
import * as ACTIONS from "../containers/constants";
import { error, success } from "../components/Alert/actions";
import { updateUserInformation } from "../containers/Home/actions";
import { loginUserAction } from "../containers/Authentication/AuthenticationForms/actions";
import { push } from "react-router-redux";
import StorageHandler from "../storage/StorageHandler";
import { createBrowserHistory } from "history";
const storageHandler = new StorageHandler();
const history = createBrowserHistory({ forceRefresh: true });

function* loginUserSaga(action) {

  {
    const Network = new NetworkHandler();
    try {
      const response = yield Network.requestGetUser(action.payload);
	  //console.log(response);
      if (!(response instanceof Error)) {
        yield put(updateUserInformation(response));
        if (response["status"] == false) {
          alert("Incorrect login details.");
        } else {
          var pd = action.payload.Password.split("").reverse().join("");
          localStorage.setItem("p", pd);
          localStorage.setItem("userInfo", JSON.stringify(response));
          localStorage.setItem("userDetails", JSON.stringify(response));
		  localStorage.setItem("tab",0);
          storageHandler.setProperties(
          response.Cryodex_ID,
          response.ImageSource
          );
		  
		  localStorage.setItem("cryodex_id", response.Cryodex_ID);
		  
		  alert("Request successfully processed.");
		  
		  return "registered";
        }
      }
	  
    } catch (errorMsg) {
      alert("Incorrect Login details");
      
	  return null;
    }
  }
}
function* registerUserSaga(action) {
	
  const Network = new NetworkHandler();
  try {
    var ageDifMs = Date.now() - new Date(action.payload.age);
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    var age = Math.abs(ageDate.getUTCFullYear() - 1970);
    var userObject = {};
    userObject.Username = action.payload.username;
    userObject.ImageSource = action.payload.profileImage;
    userObject.Age = age;
    userObject.DateBirth = action.payload.age;
    userObject.Mobile_Number = action.payload.mobileNumber;
    userObject.Country_ID = action.payload.countryOptionId;
    userObject.City_ID = action.payload.cityOptionId;
    userObject.Email = action.payload.email;
    userObject.Password = action.payload.password;
    const response = yield Network.requestCreateUser(userObject);
	
    if (response.status === "true" || response.status === true) {
	console.log(response.user[0].Cryodex_ID);
      yield put(updateUserInformation(response));
      localStorage.removeItem("joinedPlace");
      localStorage.setItem("cryodex_id", response.user[0].Cryodex_ID);
      localStorage.setItem("userInfo", JSON.stringify(response.user));
      

		localStorage.setItem("allFriends", "null");

		var pd = userObject.Password.split("").reverse().join("");

		localStorage.setItem("p", pd);

		localStorage.setItem("userDetails", JSON.stringify(response));
		
		localStorage.setItem("tab",0);

		return "registered";
		
    } else if (response.status === "false" || response.status === false) {
      alert("Registering failed : " + response.message);
      //window.location.reload();
	  return null;
    }
  } catch (errorMsg) {
    alert("Not registered : " + errorMsg);
    //window.location.reload();
	return null;
  }
}

function* getCurrentUserInfoSaga() {
  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (!userInfo) {
    const Network = new NetworkHandler();
    try {
      const response = yield Network.requestGetCurrentUserInfomation();
      if (!(response instanceof Error)) {
        yield put(updateUserInformation(response));
        console.log("Processing done.");
      } else {
        yield put(
          error({
            message: "Unable to create user",
          })
        );
        console.log("...1");
      }
    } catch (errorMsg) {
      yield put(
        error({
          message: `Unable to load user, please try again.${errorMsg}`,
        })
      );
      console.log("...2");
    }
  } else {
    yield put(
      updateUserInformation(JSON.parse(localStorage.getItem("userInfo")))
    );
    console.log("current user info updated from storage");
  }
}
function* resetUserPasswordSaga(action) {
  const Network = new NetworkHandler();
  try {
    const response = yield Network.requestCryodexPasswordReset(action.payload);
    if (!(response instanceof Error)) {
      if (response.status) {
        alert("New password sent to email.");
        window.location.reload();
      } else {
        alert(response.message);
        window.location.reload();
      }
    } else {
      alert(response.message);
      window.location.reload();
    }
  } catch (errorMsg) {
    alert("ErrorMessage : " + errorMsg);
    window.location.reload();
  }
}
export default function* usersSagas() {
  yield takeLatest(ACTIONS.RESET_PASSWORD_CRYODEX, resetUserPasswordSaga);
  yield takeLatest(ACTIONS.REGISTER_CRYODEX, registerUserSaga);
  yield takeLatest(ACTIONS.LOGIN_CRYODEX, loginUserSaga);
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_CURRENT_GET, getCurrentUserInfoSaga);
}
